<template>
    <div>
        <div class="d-flex flex-column align-items-center">

            <!-- Common main element parameters -->
            <div
                v-for="parameter in app.currentConfiguration.commonMainElementParameters"
                style="border: 0px solid black; background-color:white"
                :key="parameter.attribute.id"
                class="p-3"
            >
                <editParameterValueComponent
                    ref="editParameterValueComponent"
                    :labelOverInput="true"
                    :parameter="parameter"
                    :value.sync="parameter.value"
                    @update:value="refreshParameters"
                ></editParameterValueComponent>
            </div>

            <!-- Iterate mainElements -->
            <div
                v-for="(mainElementParameters,key,index) in app.currentConfiguration.mainElementParameters"
                :key="index"
            >
                <div
                    v-for="parameter in mainElementParameters"
                    style="border: 0px solid black; background-color:white"
                    :key="parameter.attribute.id"
                    class="p-3"
                >

                    <editParameterValueComponent
                        ref="editParameterValueComponent"
                        :labelOverInput="true"
                        :parameter="parameter"
                        :value.sync="parameter.value"
                        @update:value="refreshParameters"
                    ></editParameterValueComponent>

                    <!-- Si el paràmetre té imatge, mostrar-la -->
                    <div v-if="parameter.parameter_definition.image_from_combination">
                        <img v-if="parameter.value" :src="parameter.value.image"  style="max-width: 250px"/>
                        <img v-else-if="parameter.values[0]" :src="parameter.values[0].image"  style="max-width: 250px"/>
                    </div>
                </div>

                <!-- ------------- -->
                <!-- REMOVE BUTTON -->
                <!-- ------------- -->
                <button
                    v-visible="
                        true || multiLevel.canRemoveElement(index + 1)
                    "
                    @click="
                        removeElement(index + 1)
                    "
                    style="z-index: 998"
                    class="btn btn-outline-dark btn_rounded btn_desktop_size"
                >
                    <i class="fas fa-minus fa-sm"></i>
                </button>
            </div>

            <!-- ------------- -->
            <!-- ADD BUTTON -->
            <!-- ------------- -->
            <button
                v-if="!prop_readonly"
                @click="multiLevel.addElement()"
                class="btn btn-outline-dark btn_rounded mt-5"
            >
                <i class="fas fa-plus fa-sm"
                ></i>
            </button>

            <!-- diagnostics -->
            <diagnostics-component v-if="!prop_readonly" />

        </div>
    </div>
</template>

<script>
import { app } from "../../application.js";
import editParameterValueComponent from "./../editParameterValue.vue";
import diagnosticsComponent from "../common/diagnostics.vue";

export default {
    name: "mainElementsGenericComponent",
    data() {
        return {
            app: app,
            multiLevel: app.multiLevelHelper,
            prop_readonly: false,
            confirmBeforeLeave: true,
            parameters: [],
            mainElementDistribution: "",
            labelOverDropdown: true
        };
    },
    components: {
        editParameterValueComponent,
        diagnosticsComponent
    },
    methods: {
        refreshParameters: async function() {
            await this.app.asyncProcess(false, false);
        },
        async removeElement(index){
            var self = this;

            this.$nextTick(async () => {
                self.multiLevel.removeElement(index)
            })

            this.$forceUpdate()

            await app.asyncProcess(false, false);
        }
    },
    created() {},
    beforeMount() {
        var self = this;
    }
};
</script>

<style lang="scss">
</style>
